import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfSpec from '@elem/ui/ef-spec';
import EfXCore from '@elem/ui/ef-x-core';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.XCore');
    const { locale = 'us' } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfXCore
                title={<EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722326378837/X-core.png" />}
                desc={t('desc')}
                btnLink={['br', 'mx'].includes(locale) ? '' : `https://www.ecoflow.com/${locale}/x-core-3`}
                btnText={['br', 'mx'].includes(locale) ? '' : t('btn')}
            />
        </div>
    );
}
